// extracted by mini-css-extract-plugin
export default {"wrapper":"Options_wrapper__3KUjH","wrapper_left":"Options_wrapper_left__vfUqQ","wrapper_right":"Options_wrapper_right__eDWzD","options_img":"Options_options_img__fQsjH"};